import { FirebaseData } from "../General/FirebaseData";

export class FirebaseKeyData extends FirebaseData {

  unlocKeyId: string = "";
  lockId: string = "";
  unlocLockId: string = "";

  userId: string = ""; // EAPP
  userPhone: string = ""; // Unloc id

  setup(data: any) {
    this.unlocKeyId = typeof data.unlocKeyId === "string" ? data.unlocKeyId : "";
    this.userId = typeof data.userId === "string" ? data.userId : "";
    this.userPhone = typeof data.userPhone === "string" ? data.userPhone : "";
    this.lockId = typeof data.lockId === "string" ? data.lockId : "";
    this.unlocLockId = typeof data.userId === "string" ? data.unlocLockId : "";

    super.setup(data);
  }
}